var alertTriggerToggle = {
	add: "Ajouter une alerte",
	edit: "Modifier une alerte",
	label: {
		addAlert: "Ajouter une alerte",
		upperLimit: "Limite supérieure",
		lowerLimit: "Limite inférieure",
		upperLimitCrossed: "Limite supérieure dépassée",
		lowerLimitCrossed: "Limite inférieure dépassée"
	}
};
var fr = {
	alertTriggerToggle: alertTriggerToggle
};

export { alertTriggerToggle, fr as default };
